export const raceFormatter = (data) => (
  Object.keys(data).map((key) => ({ label: key, value: data[key] }))
);

export const customFieldFormatter = (data) => (
  data.map((elem) => ({ label: elem.label, value: elem.bulkloadField }))
);
